/**
 * @description 库位信息
 */
import request from "@/utils/request";

// 分页查询
export function queryPositionTable(data) {
  return request({
    url: "/warehousePosition/page",
    method: "post",
    data,
  });
}
